import React, { memo, useState, useEffect } from 'react';
import get from 'lodash/get';
import trim from 'lodash/trim';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import { TextInput } from 'modules/ui';

function ProfessionalAwardInput({ value, error, disabled, onChange }) {
  const [award, setAward] = useState(value);

  useEffect(() => {
    setAward(value);
  }, [value]);

  const handleYearChange = event => {
    const newYear = event.target.value;

    const newAward = {
      ...award,
      year: trim(newYear),
    };

    setAward(newAward);

    if (onChange) {
      onChange(newAward);
    }
  };

  const handleNameChange = event => {
    const newName = event.target.value;

    const newAward = {
      ...award,
      name: newName,
    };

    setAward(newAward);

    if (onChange) {
      onChange(newAward);
    }
  };

  const year = get(award, 'year', null);
  const awardName = get(award, 'name', '');

  return (
    <Grid container size={12} spacing={2}>
      <Grid size={4}>
        <NumberFormat
          customInput={TextInput}
          width={200}
          name="year"
          placeholder="Year"
          format="####"
          value={year}
          disabled={disabled}
          error={error && error.year}
          onChange={handleYearChange}
          containerClassName={disabled && 'mb-0'}
        />
      </Grid>
      <Grid size={8}>
        <TextInput
          name="name"
          placeholder="Name of Award"
          error={error && error.name}
          value={awardName}
          disabled={disabled}
          onChange={handleNameChange}
          containerClassName={disabled && 'mb-0'}
        />
      </Grid>
    </Grid>
  );
}

ProfessionalAwardInput.propTypes = {
  value: PropTypes.object,
  error: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default memo(ProfessionalAwardInput);
